import classNames from 'classnames';
import Button from 'components/styleguide/button/Button';
import Icon, { IconColor } from 'components/styleguide/icon/Icon';
import React from 'react';

const styles = require('./Tag.module.scss');

export type TagVariant =  'black' | 'default' | 'success' | 'info' | 'warning' | 'error';

const ICON_COLOR: Record<TagVariant, IconColor> = {
  default: 'disable',
  success: 'success',
  info: 'info',
  warning: 'warning-dark',
  error: 'error-dark',
  black: 'white',
};

export interface TagProps {
  children: React.ReactNode;
  className?: string;
  iconLeft?: string;
  iconLeftLabel?: string;
  iconRight?: string;
  iconRightLabel?: string;
  onIconLeftClick?: () => void;
  onIconRightClick?: () => void;
  variant?: TagVariant;
}

const Tag: React.FC<TagProps> = ({
  children,
  className,
  iconLeft,
  iconLeftLabel,
  iconRight,
  iconRightLabel,
  onIconLeftClick,
  onIconRightClick,
  variant = 'default',
}) => {
  const iconColor = ICON_COLOR[variant];

  const renderIcon = (name: string, onClick?: () => void, label?: string) => {
    const icon = (
      <Icon name={name} size="sm" color={iconColor} aria-hidden="true" />
    );

    if (onClick) {
      return (
        <Button
          type="terceary"
          size="S"
          iconLeft={name}
          iconLeftOptions={{ color: iconColor, size: 'sm' }}
          aria-label={label}
          onClick={onClick}
        />
      );
    }

    return icon;
  };

  return (
    <span className={classNames(styles.tag, styles[variant], className)}>
      {iconLeft && renderIcon(iconLeft, onIconLeftClick, iconLeftLabel)}
      {children}
      {iconRight && renderIcon(iconRight, onIconRightClick, iconRightLabel)}
    </span>
  );
};

export default Tag;
